<template>
  <div v-if="isOpen" class="fixed inset-0 z-[1000] bg-black/60" @click="closeDrawer"></div>

  <Dialog v-if="isDesktop" v-model:open="isOpen">
    <DialogTrigger v-show="props.triggerButtonName" as-child>
      <div class="mx-auto w-[calc(100%-16px)] max-w-[330px] justify-end">
        <AtomsPrimaryButton data-testid="drawer-trigger-button" :on-click="props.onClick">{{ props.triggerButtonName }}</AtomsPrimaryButton>
      </div>
    </DialogTrigger>
    <DialogContent class="!z-[1001] max-w-[640px] bg-white p-0 font-Spectral">
      <!-- shadcnのお作法的に定義しないとwarningが出るので空定義 -->
      <DialogTitle></DialogTitle>
      <DialogDescription> <slot /></DialogDescription>
    </DialogContent>
  </Dialog>

  <Drawer v-else v-model:open="isOpen">
    <DrawerTrigger v-show="props.triggerButtonName" as-child>
      <div class="mx-auto w-[calc(100%-16px)] max-w-[330px] justify-end">
        <AtomsPrimaryButton :on-click="props.onClick">{{ props.triggerButtonName }}</AtomsPrimaryButton>
      </div>
    </DrawerTrigger>
    <DrawerContent class="!z-[1001] bg-white font-Spectral">
      <!-- shadcnのお作法的に定義しないとwarningが出るので空定義 -->
      <DrawerTitle></DrawerTitle>
      <img alt="close modal" class="absolute right-0 top-0 h-10 w-10 cursor-pointer p-2" src="@/assets/icon/close/black.svg" @click="closeDrawer" />
      <DrawerDescription> <slot /></DrawerDescription>
    </DrawerContent>
  </Drawer>
</template>

<script lang="ts" setup>
import { useMediaQuery } from '@vueuse/core';

import { Dialog, DialogTitle, DialogContent, DialogTrigger, DialogDescription } from '@/components/lib/shadcn-vue/dialog';
import { Drawer, DrawerContent, DrawerTrigger, DrawerTitle, DrawerDescription } from '@/components/lib/shadcn-vue/drawer';
interface Props {
  onClick: () => void;
  triggerButtonName?: string; // 外部でボタンを配置したい場合は指定しない
  externalOpenState?: boolean; // 外部から開閉状態を制御したい場合に指定
}
const props = defineProps<Props>();
const emit = defineEmits(['update:isModalOpen']);
const isDesktop = useMediaQuery('(min-width: 768px)');
const isOpen = ref(false);
const closeDrawer = () => {
  isOpen.value = false;
};
watch(
  () => props.externalOpenState,
  (newValue) => {
    if (typeof newValue === 'boolean') {
      isOpen.value = newValue;
    }
  },
);
watch(
  () => isOpen.value,
  (newValue) => {
    emit('update:isModalOpen', newValue); // isOpenの変更を親要素に反映
  },
);
</script>

<style>
/* Dialog と Drawer のオーバーレイと内容を最前面に表示 */
[data-radix-dialog-overlay] {
  z-index: 1000 !important;
}

[data-radix-dialog-content] {
  z-index: 1001 !important;
}

[data-vaul-drawer-wrapper] [data-vaul-overlay] {
  z-index: 1000 !important;
}

[data-vaul-drawer] {
  z-index: 1001 !important;
}
</style>
